import { gql } from "@apollo/client";

export const GET_BULLETINS_QUERY = gql`
  query GET_BULLETINS_QUERY($officerId: ID!, $originatorId: ID!) {
    getBulletins(officerId: $officerId, originatorId: $originatorId) {
      details
      discussion
      id
      message
      officerId
      priority
      unread
      photos {
        id
        attachmentType {
          id
          name
        }
        confidential
        dataFileName
        description
        employee {
          id
        }
        id
        incident {
          id
          incidentNumber
        }
        lastUpdated
        ownerName
        dataUrl
        dataUrlWrapper
        unencryptedDataUrlWrapper
      }
    }
  }
`;

//exception
//  dataUrl
//  dataUrlWrapper
//  unencryptedDataUrlWrapper
